import { render } from "./RawMaterialProperties.vue?vue&type=template&id=0b42fcea&ts=true"
import script from "./RawMaterialProperties.vue?vue&type=script&lang=ts"
export * from "./RawMaterialProperties.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__